<template>
  <v-app-bar height="50px" :clipped-left="$vuetify.breakpoint.lgAndUp" app color="primary" dark>
    <v-app-bar-nav-icon @click.stop="setStatusMenu()"/>
    <v-toolbar-title style="width: 300px" class="ml-0 pl-1">
      <span style="font-weight: 300; font-size: 17px; letter-spacing: 0.3px"><b>Farsoft</b> Sales Machine</span>
    </v-toolbar-title>
    <v-spacer />

    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn
          ref="botaoLerAlertas"
          :loading="loading"
          :disabled="loading"
          @click="atualizarAlertas()"
          class="mx-1 d-none d-sm-flex"
          v-on="on"
          dark
          icon
        >
          <v-icon>fas fa-lightbulb</v-icon>
          <template v-slot:loader>
            <span class="custom-loader">
            <v-icon color="red">mdi-fan</v-icon>
          </span>
          </template>
        </v-btn>
      </template>
      <span style="font-size: 11px">ATUALIZAR ALERTAS</span>
    </v-tooltip>

    <v-menu v-if="loggedInUser !== null" transition="slide-y-transition" left offset-y :nudge-top="30" v-model="menuAlertas" :close-on-content-click="false">
      <template v-slot:activator="{ on }">
        <v-btn class="mr-1" v-on="on" icon>
          <v-badge v-if="alertas.length > 0" color="red" style="width: 40px" overlap>
            <template v-slot:badge>
              <span>
                {{ alertas.length }}
              </span>
            </template>
            <v-icon style="font-size: 23px !important">mdi-bell-outline</v-icon>
          </v-badge>
          <v-icon v-else style="font-size: 23px !important">mdi-bell-outline</v-icon>
        </v-btn>
      </template>
      <v-card v-if="alertas.length > 0" class="fs-card-notif-alertas pt-5">
        <h3 class="ml-1">
          <v-icon color="red" class="mt-n1 mr-2">mdi-bell-ring</v-icon>
          <span v-if="alertas.length > 1">Você possui {{ alertas.length }} alertas pendentes!</span>
          <span v-else>Você possui {{ alertas.length }} alerta pendente!</span>
        </h3>
        <v-btn style="position: absolute; top: 0; right: 0" class="mt-3 mr-4" icon @click="menuAlertas = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <perfect-scrollbar class="mt-5" style="height: 100%; max-height: 75vh !important">
          <v-divider class="ma-0 mr-3"/>
          <div class="mr-3 fs-card-notif-alertas-item" v-for="(item, index) in alertas" :key="index">
            <v-row class="px-2" no-gutters>
              <v-col class="py-3" md="11" @click="visualizarPedido(item.alerta)">
                {{ item.id }} | <b>Pedido:</b> {{ item.alerta.ecommerce_carrinho_id.padStart(9, '0') }} | {{ formatarDataHora(item.data_notificacao, 'DD/MM/YYYY') }} {{ item.horario_notificacao.slice(0, 5) }}<br>
                {{ item.alerta.titulo }}<br>
                {{ item.alerta.descricao }}<br>
              </v-col>
              <v-col class="pt-2" style="text-align: right" md="1">
                <v-btn @click="abrirInteracao(item)" icon>
                  <v-icon color="green">mdi-checkbox-marked-circle-outline</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-divider class="ma-0"/>
          </div>
        </perfect-scrollbar>
        <v-switch
          v-model="autoRefresh"
          label="Atualizar automaticamente"
          class="mt-2"
          color="#2A2F50"
          hide-details
        ></v-switch>
      </v-card>
    </v-menu>

    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn
          @click="toggleFullScreen()"
          class="d-none d-sm-flex mr-1"
          v-on="on"
          dark
          icon
        >
          <v-icon style="font-size: 18px !important">fas fa-expand</v-icon>
        </v-btn>
      </template>
      <span style="font-size: 11px">TELA CHEIA</span>
    </v-tooltip>

    <v-menu
      v-if="loggedInUser !== null"
      left
      bottom
      offset-y
      :nudge-top="28"
      transition="slide-y-transition"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          class="ml-n1 pt-0"
          v-if="loggedInUser !== null"
          color="white"
          v-on="on"
          text
        >
          <v-icon style="font-size: 22px !important" class="mr-2" color="white">
            mdi-account-circle
          </v-icon>
          {{ primeiroNomeUsuario }}
        </v-btn>
      </template>
      <v-list>
        <template v-for="m in menu">
          <v-divider
            v-if="m.divider"
            :key="m.id"
            class="fs-divider-menu"
          />
          <v-list-item
            v-else
            :key="m.id"
            @click="goRota(m.rota)"
          >
            <v-list-item-icon v-if="m.divider === false" class="mr-0">
              <v-icon>{{ m.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title
              v-if="m.divider === false"
              style="color: #2a2f50"
            >
              {{ m.title }}
            </v-list-item-title>
          </v-list-item>
        </template>
      </v-list>
    </v-menu>

    <v-dialog v-model="dialogDetalhes" max-width="1000px">
      <detalhespedido v-if="dialogDetalhes" :itemMostrarDetalhes="pedidoDoAlertaSelecionado" :fecharDetalhes="fecharDetalhes"></detalhespedido>
    </v-dialog>

    <v-dialog v-model="dialogInteracao" max-width="700px">
      <v-card class="pa-3 pt-5" flat>
        <h3 class="ml-3">Adicionar Interação ao Pedido</h3>
        <v-divider style="margin: 17px 0px 12px 0px"></v-divider>
        <v-form autocomplete="off" class="mt-n2">
          <v-radio-group v-model="interacao.tipo" row>
            <v-radio color="#2A2F50" label="Envio de Email" value="Envio de Email"></v-radio>
            <v-radio color="#2A2F50" label="Contato Telefônico" value="Contato Telefônico"></v-radio>
            <v-radio color="#2A2F50" label="Feedback do Cliente" value="Feedback do Cliente"></v-radio>
          </v-radio-group>
          <v-textarea
            id="fs-textarea-descricao"
            label="Descrição *"
            placeholder=" "
            rows="8"
            spellcheck="false"
            class="mt-n3 mb-n5"
            v-model="interacao.descricao"
            outlined
          ></v-textarea>
        </v-form>
        <v-divider style="margin: 12px 0px 12px 0px"></v-divider>
        <v-card-actions style="padding: 0px">
          <v-spacer></v-spacer>
          <v-btn color="#2A2F50" @click="updateAlerta()" dark small>
            <v-icon class="mr-1" style="font-size: 15px !important">mdi-content-save</v-icon>
            Salvar
          </v-btn>
          <v-btn color="warning" @click="dialogInteracao = false" dark small>
            <v-icon class="mr-1" style="font-size: 15px !important">mdi-close</v-icon>
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-app-bar>
</template>

<script>
import { mapMutations, mapState, mapGetters, mapActions } from 'vuex'
import * as interacaoApi from '@/api/interacao' // eslint-disable-line
import { listFiltro, edit } from '@/api/alertaNotificacao' // eslint-disable-line
import moment from 'moment'

export default {
  components: {
    detalhespedido: () => import('@/views/app/crm/listagemdepedidos/tablepedidos/dialogdetalhes')
  },
  data () {
    return {
      loading: false,
      dialogDetalhes: false,
      alertas: [],
      dialogInteracao: false,
      interacao: { descricao: '', tipo: 'Envio de Email' },
      autoRefresh: true,
      pedidoDoAlertaSelecionado: null,
      alertaSelecionado: null,
      menuAlertas: false,
      menu: [
        {
          id: 8,
          title: 'Logout (Sair)',
          rota: '/logout',
          icon: 'mdi-lock-open-outline',
          divider: false
        }
      ]
    }
  },
  async mounted () {
    await this.loadAlertas()
    setInterval(() => {
      // console.log('executou o timer')
      if (window.localStorage.getItem('userInfo')) {
        this.autoRefreshAlertas()
      }
    }, 30000) // 60000

    // window.addEventListener('beforeunload', function (e) {
    //   console.log('Limpou o set interval')
    //   clearInterval(window._alerta_)
    // })
  },
  computed: {
    ...mapGetters('authData', ['loggedInUser']),
    ...mapState({
      statusMenu: state => state.menu.statusMenu,
      confirm: state => state.global.confirm
    }),
    primeiroNomeUsuario () {
      if (this.loggedInUser !== null) {
        if (this.loggedInUser.nome !== undefined) {
          const nome = this.loggedInUser.nome.split(' ')
          return nome[0]
        } else {
          return ' '
        }
      } else {
        return ' '
      }
    }
  },
  methods: {
    ...mapActions({
      signOut: 'authData/signOut',
      carregarDashboard: 'dashboard/carregarDashboard'
    }),
    ...mapMutations({
      setStatusMenu: 'menu/setStatusMenu',
      setSnackbar: 'global/setSnackbar'
    }),
    ...mapActions({
      mostrarMsg: 'global/mostrarMsg',
      loadPedidos: 'pedidos/loadPedidos',
      signOut: 'authData/signOut',
      getPedido: 'pedidos/getPedido'
    }),
    async autoRefreshAlertas () {
      if (this.autoRefresh) {
        this.atualizarAlertas()
      }
    },
    async atualizarAlertas () {
      // console.log('atualizarAlertas')
      this.loading = true
      // Força ativar a animação do botão (top)
      if (this.$refs.botaLerAertas !== undefined) {
        this.$refs.botaoLerAlertas.loading = true
      }
      const n = this.alertas.length
      await this.loadAlertas()
      const n2 = this.alertas.length
      // // Desativa o custom-loader
      setTimeout(() => {
        this.loading = false
        if (n2 !== n) {
          this.mostrarMsg({ msg: 'Alertas atualizados, verifique!', color: '#ff0073', timeout: 3000 })
        } else {
          this.mostrarMsg({ msg: 'Alertas recarregados, porém nada de diferente!', color: 'blue', timeout: 3000 })
        }
      }, 1500)
    },
    // Websockets : start
    formatarDataHora (data, format) {
      return moment(data).format(format)
    },
    async onCarrinhoFinalizado () {
      this.mostrarMsg({ msg: 'Carrinho Finalizado, verifique!', color: 'green', timeout: 3000 })
      await this.carregarDashboard({ dataInicial: moment(this.getDataInicial + ' 00:00:00'), dataFinal: moment(this.getDataFinal + ' 23:59:59') })
      await this.loadAlertas()
    },
    async onCarrinhoGerado () {
      this.mostrarMsg({ msg: 'Item lançado no Carrinho, verifique!', color: 'orange', timeout: 3000 })
      await this.carregarDashboard({ dataInicial: moment(this.getDataInicial + ' 00:00:00'), dataFinal: moment(this.getDataFinal + ' 23:59:59') })
      await this.loadAlertas()
    },
    async onCarrinhoCancelado () {
      this.mostrarMsg({ msg: 'Carrinho Cancelado, verifique!', color: 'red', timeout: 3000 })
      await this.carregarDashboard({ dataInicial: moment(this.getDataInicial + ' 00:00:00'), dataFinal: moment(this.getDataFinal + ' 23:59:59') })
      await this.loadAlertas()
    },
    async onInteracaoCliente () {
      this.mostrarMsg({ msg: 'Interação de Cliente, verifique!', color: '#9400D3', timeout: 3000 })
      await this.carregarDashboard({ dataInicial: moment(this.getDataInicial + ' 00:00:00'), dataFinal: moment(this.getDataFinal + ' 23:59:59') })
      await this.loadAlertas()
    },
    async onNewCarrinho () {
      this.mostrarMsg({ msg: 'Novo carrinho no ecommerce, verifique!', color: 'blue', timeout: 3000 })
      await this.carregarDashboard({ dataInicial: moment(this.getDataInicial + ' 00:00:00'), dataFinal: moment(this.getDataFinal + ' 23:59:59') })
      await this.loadAlertas()
    },
    async onMessage (message) {
      this.setSnackbar({ msg: message, color: 'green' })
      await this.loadAlertas()
    },
    async onNewAlerta () {
      this.mostrarMsg({ msg: 'Novo Alerta, verifique!', color: '#ff0073', timeout: 3000 })
      // this.setSnackbar({ msg: 'Chegou um novo Alerta!', color: 'green' })
      await this.loadAlertas()
    },
    goRota (r) {
      if (r === '/logout') {
        this.signOut()
        this.$router.push('/app/sessions/signIn')
      } else {
        this.$router.push(r)
      }
    },
    async loadAlertas () {
      const userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
      if ((userInfo) && (userInfo.pessoa !== undefined) && (userInfo.pessoa !== null)) {
        const filtroTopbar = [
          { field: 'usuario_id', value: userInfo.pessoa },
          { field: 'vista', value: 'N' },
          { field: 'data_notificacao', value: moment().utcOffset('-0300').format('YYYY-MM-DD HH:mm:ss') }
        ]
        try {
          const res = await listFiltro('/admin/alertas-notificacoes-filtro', { tipo: 'filtro', query: this.querySerialize('filtroTopbar', filtroTopbar) }, 'all=S')
          this.alertas = res.data
        } catch (error) {
          this.setSnackbar({ msg: `Ocorreu um erro! ${error}` })
        }
      }
    },
    async visualizarPedido (alerta) {
      this.menuAlertas = false
      try {
        this.pedidoDoAlertaSelecionado = (await this.getPedido(alerta.ecommerce_carrinho_id))[0]
        this.dialogDetalhes = true
      } catch (error) {
        this.setSnackbar({ msg: `Ocorreu um erro! ${error}` })
      }
    },
    fecharDetalhes () {
      this.dialogDetalhes = false
    },
    async abrirInteracao (item) {
      // Limpar conteúdo
      this.interacao.descricao = ''
      this.interacao.tipo = 'Envio de Email'
      this.dialogInteracao = true
      try {
        this.pedidoDoAlertaSelecionado = (await this.getPedido(item.alerta.ecommerce_carrinho_id))[0]
        this.alertaSelecionado = item
        document.getElementById('fs-textarea-descricao').focus()
      } catch (error) {
        this.setSnackbar({ msg: `Ocorreu um erro! ${error}` })
      }
    },
    async updateAlerta () {
      if (this.interacao.descricao.length > 0) {
        this.dialogInteracao = false
        if (await this.confirm.open('Visualizar Alerta', 'Deseja marcar esse alerta como visualizado?', { color: 'green' })) {
          const userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
          const data = {
            ecommerce_carrinho_id: this.pedidoDoAlertaSelecionado.id,
            usuario_id: userInfo.pessoa,
            cliente_id: this.pedidoDoAlertaSelecionado.pessoa_id,
            tipo: this.interacao.tipo,
            descricao: this.interacao.descricao
          }
          try {
            await interacaoApi.add({}, data)
            await edit('editar', this.alertaSelecionado.id, { vista: 'S' })
            this.setSnackbar({ msg: 'Alerta atualizado com Sucesso!', color: 'green' })
            this.loadAlertas()
            this.loadPedidos()
          } catch (error) {
            this.setSnackbar({ msg: `Ocorreu um erro! ${error}` })
          }
        } else {
          this.dialogInteracao = true
        }
      } else {
        this.setSnackbar({ msg: 'Informe a DESCRIÇÃO da Interação!' })
      }
    },
    toggleFullScreen () {
      if ((document.fullScreenElement && document.fullScreenElement !== null) ||
        (!document.mozFullScreen && !document.webkitIsFullScreen)) {
        if (document.documentElement.requestFullScreen) {
          document.documentElement.requestFullScreen()
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen()
        } else if (document.documentElement.webkitRequestFullScreen) {
          document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT)
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        }
      }
    },
    querySerialize (nome, filtro) {
      let query = ''
      for (let i = 0; i < filtro.length; i++) {
        if (i === 0) query = query + nome
        query = query + encodeURIComponent(`[${i}]`) + '=' + encodeURIComponent(JSON.stringify(filtro[i]))
        if (i < filtro.length - 1) query = query + `&${nome}`
      }
      query = query.replace(/%2C/g, ',')
      return query
    }
  }
}
</script>

<style lang="scss">
  // @import '../../../assets/menu/layout.scss';
  // @import '../../../assets/menu/menu-toggle-btn.scss';
  // @import '../../../assets/menu/menu.scss';
  // @import '../../../assets/menu/content-overlay.scss';
  // @import '../../../assets/menu/media-queries.scss';
  // @import '../../../assets/farsoft/farsoft.scss';
  .ps {
    height: 100vh;
  }
  .fs-divider-menu {
    padding: 0;
    margin: 5px;
  }
  .fs-snackbar {
    border: 1px solid rgba(255, 255, 255, 0.329);
    z-index: 1000;
    bottom: 50px;
    transition: 1s;
    padding: 8px 15px 8px 30px;
    color: white;
    border-radius: 5px;
    // opacity: .7;
    letter-spacing: 1px;
    margin-bottom: 10px;
    text-align: center;
    font-size: 13px;
    font-weight: 300;
    right: 27px;
    position: absolute;
    box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
  }
  .fs-card-notif-alertas {
    width: 400px;
    padding: 15px 5px 15px 15px;
  }
  .fs-card-notif-alertas-item:hover {
    background-color: #d3cfcf36;
    transition: .2s;
    cursor: pointer;
  }
  /*CLASSE PARA MOVIMENTAR O ICONE*/
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  .fs-topbar-icon {
    font-size: 10px !important;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>
